import React, { useEffect, useState } from 'react'
import ButtonComp from '../../../Components/ButtonComp/ButtonComp'
import CustomInput from '../../../Components/InputCompo/CustomInput'
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp';
import CustomSelection from '../../../Components/SelectionComp/CustomSelection';
import { useMutation, useQuery } from '@tanstack/react-query';
import { BronzeSectionGsnGet, EOIGet } from '../../../Store/auth/register';
import { enqueueSnackbar } from 'notistack';
import Loading from '../../../Components/Loader/Loading';

const OrganizationDetails = ({setSubTabs}) => {

    const [initialValues, setInitialValues] = useState({});

    const gsnNoFromStorage = localStorage.getItem('gsn_no');
    
   
    const { data: questions } = useQuery({
        queryKey: 'EOI',
        queryFn: () => EOIGet(gsnNoFromStorage ? gsnNoFromStorage : ''),
    });

    // 

    
    const documents = [
        {
          type: 'text', 
          question_no: 'legal_name_organisation', 
          question: 'Legal name of your Organization ', 
          description: '', 
          depend_question: '', 
          condition: 'equals', 
          value: 'yes', 
          validation:'text', 
          options: [], 
          mandatory: 1,
        },
        {
          type: 'text', 
          question_no: 'organisation_it_pan', 
          question: 'Organization IT PAN ', 
          description: '', 
          depend_question: '',
          condition: 'equals', 
          value: 'yes',
          validation:'pan', 
          options: [],
          mandatory: 1,
        },
        {
          type: 'text', 
          question_no: 'contact_person_name', 
          question: 'Contact Person Name ', 
          description: '', 
          depend_question: 'field3',
          condition: 'equals', 
          value: 'yes', 
          validation:'text',
          options: [],
          mandatory: 1,
        },
        {
          type: 'email', 
          question_no: 'contact_persons__email_id', 
          question: 'Contact Person’s Email ID', 
          description: '', 
          depend_question: 'field4',
          condition: 'equals', 
          value: 'yes', 
          validation:'email',
          options: [],
          mandatory: 1,
        },
        {
          type: 'text', 
          question_no: 'contact_persons_number', 
          question: 'Contact Person’s Contact Number *', 
          description: 'We prefer mobile number to filled here', 
          depend_question: 'field5',
          condition: 'equals', 
          value: 'yes', 
          validation:'number',
          options: [],
          mandatory: 1,
        },
        
        
      ];

      const modelSchema = Yup.object().shape(
        documents.reduce((schema, field) => {
            if (field.mandatory === 1 && field.type.toLowerCase() !== 'section') {
                let validator = Yup.string().required(`${field.question} is required`);
    
                if (field.validation) {
                  switch (field.validation.toLowerCase()) {
                      case 'email':
                          validator = Yup.string()
                              .email('Invalid email address')
                              .required(`${field.question} is required`);
                          break;
                      case 'number':
                          validator = Yup.string()
                              .matches(/^\d{10}$/, "Invalid Number. It should be 10 digits.")
                              .required(`${field.question} is required`);
                          break;
                      case 'pan':
                          validator = Yup.string()
                              .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Invalid PAN Number. It should be in the format: ABCDE1234F.')
                              .required(`${field.question} is required`);
                          break;
                      case 'pincode':
                          validator = Yup.string()
                              .matches(/^\d{4}$|^\d{6}$/, 'PIN code must be exactly 6 digits')
                              .required(`${field.question} is required`);
                          break;
                      case 'areacode':
                          validator = Yup.string()
                              .matches(/^(123|456|789)$/, 'Incorrect area code')
                              .required(`${field.question} is required`);
                          break;
                      case 'website':
                          validator = Yup.string()
                              .url('Please enter a valid URL')
                              .required(`${field.question} is required`);
                          break;
                      case 'mobile':
                          validator = Yup.string()
                              .matches(/^(?:[0-9]{10}|[0-9]{7})$/, 'Invalid contact number')
                              .required(`${field.question} is required`);
                          break;
                      case 'darpan':
                          validator = Yup.string()
                              .test(
                                  'is-valid-darpan',
                                  'Darpan Id should be in the format: XX/1234/1234567',
                                  (value) => value?.toUpperCase() === 'NA' || /^([A-Z]{2}\/\d{4}\/\d{7})$/.test(value)
                              )
                              .required(`${field.question} is required`);
                          break;
                      case 'password':
                          validator = Yup.string()
                              .min(8, 'Password must be at least 8 characters long')
                              .required(`${field.question} is required`);
                          break;
                      case 'multiselect dropdown':
                          validator = Yup.array().required(`${field.question} is required`);
                          break;
                      case 'attach':
                          validator = Yup.object().required(`${field.question} is required`);
                          break;
                      default:
                          validator = Yup.string().required(`${field.question} is required`);
                          break;
                  }
              }
              
    
                schema[field.question_no] = validator;
            }
    
            return schema;
          }, {})
        );

        useEffect(() => {
            const savedData = JSON.parse(localStorage.getItem('formData')) || {};
            
            if (questions && questions?.documents) {
                // If API data is available, merge it with localStorage data
                const apiData = questions.documents;
    
                const formValues = documents.reduce((acc, field) => {
                    acc[field.question_no] = apiData[field.question_no] || savedData[field.question_no] || '';
                    return acc;
                }, {});
    
                setInitialValues(formValues); // Set form values based on API and localStorage
            } else {
                // If API data is unavailable, just use the localStorage data
                const formValues = documents.reduce((acc, field) => {
                    acc[field.question_no] = savedData[field.question_no] || '';
                    return acc;
                }, {});
    
                setInitialValues(formValues); // Set form values from localStorage only
            }
        }, [questions]);

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: modelSchema,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                // Convert the form data into a flat object
                const tempData = documents.reduce((acc, field) => {
                    acc[field.question_no] = values[field.question_no];
                    return acc;
                }, {});
    
                // Retrieve existing data from localStorage
                const existingData = JSON.parse(localStorage.getItem('formData')) || {};
    
                // Merge new data with existing data
                const updatedData = {
                    guidestar_number:gsnNoFromStorage,
                    email_id:tempData.contact_persons__email_id,
                    ...existingData,
                    ...tempData,
                };
                
    
                // Save updated data to localStorage
                localStorage.setItem('formData', JSON.stringify(updatedData));
                // 
                
                setSubTabs({'Head and Finance Team Details': true });
                
                // localStorage.clear('formData')
                // await submitReg(structuredData);

                
            } catch (error) {
                console.error(error);
            } finally {
                setSubmitting(false);
            }
        },
    });    

  return (
    <div>
        <form className='flex flex-col gap-[30px]'  action="" onSubmit={formik.handleSubmit}>
                
                {/* <div className=''>
                    <ParagraphComp className='font-bold text-lg' text='Legal Information' />
                </div> */}
                <div className='flex flex-wrap gap-[30px] justify-between w-[100%]'>
                    {documents.slice(0, 2).map(Fields =>
                    <>
                    
                        <div className='w-[48%]'>
                            <CustomInput 
                                required
                                {...formik.getFieldProps(Fields.question_no)}
                                name={Fields.question_no} label={Fields.question}
                                onBlur={formik.handleBlur}  
                            />
                            <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                            <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                        </div>
                    </>
                    )}
                    
                </div >
                <div className=''>
                    <ParagraphComp className='font-bold text-lg' text='Contact information and other details. Please provide name and other details of the person who will  be interacting with GuideStar India for  the certification process' />
                </div>
                <div className='flex flex-wrap gap-[30px] justify-between w-[100%]'>
                    {documents.slice(2 , 5).map(Fields =>
                    <>
                    
                        <div className='w-[48%]'>
                            <CustomInput 
                                required
                                {...formik.getFieldProps(Fields.question_no)}
                                name={Fields.question_no} label={Fields.question}
                                onBlur={formik.handleBlur}  
                            />
                            <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                            <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                        </div>
                    </>
                    )}
                    
                </div >

                {/* <div className=''>
                    <ParagraphComp className='font-bold text-lg' text='Certificate Application' />
                </div> */}
                <div className='flex flex-wrap gap-[30px] justify-between w-[100%]'>
                    {documents.slice(5 , 8).map(Fields =>
                    <>
                    
                        {Fields.type.toLowerCase() === 'dropdown'
                            ?
                            <div className='w-[100%]'>
                                <>
                                    <CustomSelection required options={Fields?.options}
                                    {...formik?.getFieldProps(Fields?.question_no)}
                                    name={Fields.question_no} label={Fields.question}
                                />
                                {/* <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={TempFormik?.values?.[Fields.question_no] && TempFormik?.errors?.[Fields.question_no]} /> */}
                                <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />                                       </>
                            </div>
                                :
                                Fields.type.toLowerCase() === 'text' || Fields.type.toLowerCase() === 'number' || Fields.type.toLowerCase() === 'date' ?
                                <div className='w-[48%]'>
                                    <CustomInput 
                                        required={Fields.required === '1' ? true : false}
                                        {...formik.getFieldProps(Fields.question_no)}
                                        name={Fields.question_no} label={Fields.question}
                                        onBlur={formik.handleBlur}  
                                        type={Fields.type}
                                    />
                                    <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                                    <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                                </div>
                                :''
                        }
                    </>
                    )}
                    
                </div >

                <div className='flex justify-end'>
                    <ButtonComp type={'submit'} className='px-[20px] py-[6px] h-[40px] text-white bg-[#004878] rounded-full ' text='Save & Next' />
                </div>

            </form >
    </div>
  )
}

export default OrganizationDetails